import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LinkUrlTemplate extends BaseOption {
  static defaultValue = "";

  static userInterfaceComponent = {
    label: "Links to",
    component: inspectorTools.SIMPLE_INPUT,
    descriptionMessage:
      "A path, with {fieldName} standing in for a field on the bound entity. "
      + "Example: /questionnaire/{id}",
    props: {},
  };
}
